enum CART_TYPES {
  CITATION = 'citation',
  DONATION = 'donation',
  INTAKE = 'intake',
  OUTCOME = 'outcome',
  PRODUCT = 'product',
}

enum CART_CHECKOUT_METHODS {
  ADOPT = 'adopt_app',
  MANUAL = 'manual',
  MOBILE = 'mobile_checkout',
}

enum MEDICAL_COST_TYPES {
  MEDICATIONS = 'medications',
  VACCINATIONS = 'vaccinations',
  PROCEDURES = 'procedures',
  DIAGNOSTICS = 'diagnostics',
  SURGERIES = 'surgeries',
  EXAMS = 'exams',
}

enum MEDICATION_COST_TYPES {
  PER_UNIT = 'PER UNIT',
  PER_DOSE = 'PER MEDICATION',
}

export { CART_CHECKOUT_METHODS, CART_TYPES, MEDICAL_COST_TYPES, MEDICATION_COST_TYPES };
